import { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { SignUpForm7ways } from '@components/Block'

function FreeReport (props) {

    const [lgShow, setLgShow] = useState(false);
    
return (
    <>
    <div className="sevenWays__FreeReport pt-3 text-white">
        <Container className="py-5">
            <Row>
                <Col lg={4} md={5} xs={5}>
                <img className="sevenWays__FreeReport--img mt-3" src="../images/7ways/img-7-ways-to-improve-memory-free-e-book01.png" alt="Workbook" />
                </Col>
                <Col lg={4} md={7} xs={7}>
                    <p className="mt-5">
                        <strong>A healthier brain can help you:</strong>
                        <br /><br />
                        - Get better jobs<br />
                        - Perform better at work<br />
                        - Have better health<br />
                        - Improve results at school<br />
                        - Improve your relationships<br />
                        - Improve your overall life
                    </p>
                </Col>
                <Col lg={4} md={12} xs={12}>
                <h4 className="text-center mt-5">DOWNLOAD THE FREE REPORT</h4>
                <Button variant="default px-5 py-2 mt-4 text-left" onClick={() => setLgShow(true)}>DOWNLOAD NOW</Button>
                </Col>
            </Row>
        </Container>
    </div>
    <SignUpForm7ways show={lgShow} onHide={() => setLgShow(false)} global={props.global}/>
    <style jsx global>{`
            .sevenWays__FreeReport .form-group{
                max-width: 90%;
            }
            .sevenWays__FreeReport .btn{
                margin-left: 10px;
            }
        `}
    </style>
    <style jsx>{`
                .sevenWays__FreeReport{
                    background: #47d9bf;
                    font-size: 1rem;
                }
                h4{
                    font-size: 1.4rem;
                }
                @media (max-width: 767px) {
                    .sevenWays__FreeReport--img{
                        width: 85%;
                        margin-top: 40px!important;
                    }
                }
                .google-captcha > div > div > div > div{
                    margin: 1rem auto;
                }
                .error_chk {
                    border: 1px solid red !important;
                }
            `}
        </style>
    </>
);
}

export default FreeReport;